<script lang="ts">
    import TranslatedFieldErrors from '$lib/components/util/TranslatedFieldErrors.svelte';
    import Button from '$lib/daisyUiComponents/ButtonVV.svelte';
    import { toast } from '$lib/stores.js';
    import { CHECKOUT__CUSTOMER_IS_INACTIVE, NO_MATCHING_CUSTOMER_FOUND } from '$lib/util/shopwareErrorCodes';
    import { sendFormToasts } from '$lib/util/util.js';
    import { Control, Field, Label } from 'formsnap';
    import { t } from 'svelte-i18n';
    import { superForm } from 'sveltekit-superforms';
    import { valibotClient } from 'sveltekit-superforms/adapters';
    import type { PageData } from './$types';
    import { loginFormSchema } from '$lib/util/formSchemas/loginFormSchema';
    import PasswordField from '$lib/components/util/PasswordField.svelte';
    import VVMDualHeader from '$lib/components/util/VVMDualHeader.svelte';
    import { useLocaleContext } from '$lib/context.js';

    const lang = useLocaleContext();

    export let data: PageData;

    const form = superForm(data.form, {
        validators: valibotClient(loginFormSchema),
        onResult: ({ result }) => {
            if (result.type === 'redirect') {
                location.replace(result.location);
            } else if (result.type === 'error' || result.type === 'failure') {
                if (result.data.form.message.text === CHECKOUT__CUSTOMER_IS_INACTIVE) {
                    sendFormToasts($toast, { type: 'error', text: $t('shop.error.customerInactive') });
                } else if (result.data.form.message.text === NO_MATCHING_CUSTOMER_FOUND) {
                    sendFormToasts($toast, { type: 'error', text: $t('shop.error.customerNotFound') });
                } else {
                    sendFormToasts($toast, { type: 'error', text: $t('shop.error.loginFailed') });
                }
            }
        }
    });
    const { form: formData, enhance, submitting, delayed } = form;
</script>

<svelte:head>
    <title>{$t('account.login.meta.title')}</title>
    <meta name="description" content={$t('account.login.meta.description')} />
</svelte:head>

<div class="font-jost flex flex-col justify-center items-center">
    <div class="my-44">
        <div>
            <VVMDualHeader centerText small={$t('account.login.smallHeader')} big={$t('account.login.bigHeader')} />
            <div class="bg-white px-8 py-6 mt-10 mx-auto max-w-[17.5rem]">
                <form class="flex flex-col gap-7" method="POST" use:enhance>
                    <div class="flex gap-3.5 flex-col w-full">
                        <div>
                            <Field {form} name="email">
                                <Control let:attrs>
                                    <Label class="text-darkgrey label-text">{$t('account.login.email')}</Label>
                                    <input
                                        {...attrs}
                                        type="email"
                                        bind:value={$formData.email}
                                        autocomplete="email"
                                        class="input mt-0.5"
                                    />
                                </Control>
                                <TranslatedFieldErrors />
                            </Field>
                        </div>
                        <div>
                            <Field {form} name="password">
                                <Control let:attrs>
                                    <Label class="text-darkgrey label-text">{$t('account.login.password')}</Label>
                                    <PasswordField {attrs} bind:password={$formData.password} />
                                </Control>
                                <TranslatedFieldErrors />
                            </Field>

                            <a
                                type="button"
                                class="ml-auto block mt-2.5 tracking-wide font-medium text-right cursor-pointer select-none text-secondary text-[0.813rem] hover:text-secondary/75"
                                href="/{lang}/login/forgot-password"
                            >
                                {$t('account.login.forgotPassword')}
                            </a>
                        </div>
                    </div>
                    <div>
                        <Button color="primary" class="w-full" submit disabled={$submitting} loading={$delayed}>
                            {$t('account.login.login')}
                        </Button>
                        <!--<div class="flex items-center gap-2">
                            <input
                                type="checkbox"
                                id="checkbox-keepLoggedIn"
                                class="checkbox border-primary [--chkbg:white] [--chkfg:theme(colors.primary)]"
                            />
                            <label for="checkbox-keepLoggedIn" class="text-sm text-darkgrey tracking-wide"
                                >{$t('account.login.keepLoggedIn')}</label
                            >
                        </div>-->
                    </div>
                </form>
            </div>
        </div>
        <div class="text-center mt-11 max-w-[17.5rem]">
            <div class="text-darkgrey text-sm font-medium tracking-wide mb-3">{$t('account.login.newToVVM')}</div>
            <div class="mx-auto px-8">
                <Button color="secondary" href="/{lang}/register" class="w-full">{$t('account.login.register')}</Button>
            </div>
        </div>
    </div>
</div>
